// Declare action names as constants with uppercase string
/* eslint-disable no-throw-literal */
import ApiService from '../services/ApiService';
import { message } from 'antd';
import { DialogActions } from '@material-ui/core';

export const IDM_BEGIN = 'ERAPIDS_BEGIN';
export const IDM_SUCCESS = 'ERAPIDS_SUCCESS';
export const IDM_FAILURE = 'ERAPIDS_FAILURE';

export const IDM_SCREEN_BEGIN = 'ERAPIDS_SCREEN_BEGIN';
export const IDM_SCREEN_SUCCESS = 'ERAPIDS_SCREEN_SUCCESS';
export const IDM_SCREEN_FAILURE = 'ERAPIDS_SCREEN_FAILURE';

export const ERAPIDS_TOKEN_BEGIN = 'ERAPIDS_TOKEN_BEGIN';
export const ERAPIDS_TOKEN_SUCCESS = 'ERAPIDS_TOKEN_SUCCESS';
export const ERAPIDS_TOKEN_FAILURE = 'ERAPIDS_TOKEN_FAILURE';

export const ERAPIDS_REFRESHTOKEN_BEGIN = 'ERAPIDS_REFRESHTOKEN_BEGIN';
export const ERAPIDS_REFRESHTOKEN_SUCCESS = 'ERAPIDS_REFRESHTOKEN_SUCCESS';
export const ERAPIDS_REFRESHTOKEN_FAILURE = 'ERAPIDS_REFRESHTOKEN_FAILURE';

export const EMPLOYEE_BY_ID_BEGIN = 'EMPLOYEE_BY_ID_BEGIN';
export const EMPLOYEE_BY_ID_SUCCESS = 'EMPLOYEE_BY_ID_SUCCESS';
export const EMPLOYEE_BY_ID_FAILURE = 'EMPLOYEE_BY_ID_FAILURE';

export const ACCEPT_DISCLAIMER_BEGIN = 'ACCEPT_DISCLAIMER_BEGIN';
export const ACCEPT_DISCLAIMER_SUCCESS = 'ACCEPT_DISCLAIMER_SUCCESS';

export const DESTROY_SESSION = 'DESTROY_SESSION';
export const CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';

export const GET_SITE_ID_REQUEST = 'GET_SITE_ID_REQUEST';
export const GET_SITE_ID_SUCCESS = 'GET_SITE_ID_SUCCESS';
export const GET_SITE_ID_FAILURE = 'GET_SITE_ID_FAILURE';

export function fetchIDM(data, props) {
    return async dispatch => {
        dispatch(IDMBegin());

        await ApiService.authUserErapids(data)
            .then(
                resultAuth => {

                    if (resultAuth.IsAuthenticated) {
                        IDMScreenBegin();
                        ApiService.getSiteId().then(
                            resultSite => {
                                dispatch(getSiteIdSuccess(resultSite.data));
                                //Se valida el rol administrador general que sobrepone las validaciones existentes
                                let rolGeneral = resultAuth.User.Roles.filter(x => x.NameRole === "Administrador General");

                                ApiService.getScreenByUser(
                                    {
                                        ApplicationId: resultAuth.ApplicationId,
                                        UserId: resultAuth.UserId
                                    }, data.token).then(
                                        resultScreen => {

                                            //Se agrega validación si el usuario tiene permiso especial a la pantalla de la Matriz, solo se podrá visualizar abordo
                                            let notOilScreens = [];
                                            if (rolGeneral.length > 0) {
                                                notOilScreens = resultScreen;
                                            }
                                            else {
                                                if (resultScreen.some(scr => scr.ScreenName === 'ComplianceMatrixbyPositionScreenAbordo') && resultSite.data === 'HUB')
                                                {notOilScreens = resultScreen.filter(scr =>
                                                    (scr.ScreenName !== 'ComplianceMatrixbyPositionScreenAbordo'));
                                                }
                                                else if (resultScreen.some(scr => scr.ScreenName === 'ComplianceMatrixbyPositionScreen') && resultSite.data !== 'HUB')
                                                {notOilScreens = resultScreen.filter(scr =>
                                                    (scr.ScreenName !== 'ComplianceMatrixbyPositionScreen'));
                                                }
                                                else
                                                {notOilScreens = resultScreen.filter(scr =>
                                                    (scr.ScreenName !== 'ComplianceMatrixbyPositionScreenAbordo')
                                                    ||(scr.ScreenName === 'ComplianceMatrixbyPositionScreenAbordo' && resultSite.data !== 'HUB'));
                                                }
                                            }

                                            ApiService.checkSystemTrainingPermission(resultAuth.User.IdCompany).then(
                                                resultCheck => {

                                                    var screen;

                                                    if (rolGeneral.length === 0) {
                                                        notOilScreens = notOilScreens.filter(scr => // scr.ScreenName !== 'WorkCycleScreen' &&
                                                            /*Nuevas condiciones*/
                                                            //scr.ScreenName !== 'BookmarksScreen'
                                                            scr.ScreenName !== 'ClientReportScreen'
                                                            && scr.ScreenName !== 'ProcessScreen'
                                                            && scr.ScreenName !== 'ManagementReportScreen'
                                                            && scr.ScreenName !== 'CompanyScreen'
                                                            && scr.ScreenName !== 'ClientProcedureScreen'
                                                            && scr.ScreenName !== 'HomologousProcedureScreen'
                                                            && scr.ScreenName !== 'TechnicalRepresentativeScreen'
                                                            && scr.ScreenName !== 'AdministrativeRepresentativeScreen'
                                                            && scr.ScreenName !== 'SSPARepresentativeScreen'
                                                            && scr.ScreenName !== 'PEPRepresentativeScreen'
                                                            && scr.ScreenName !== 'ACCPBossScreen'
                                                            && scr.ScreenName !== 'ACCPSupervisorScreen'
                                                            //&& scr.ScreenName !== 'ComplianceMatrixbyPositionScreen'
                                                        );

                                                        if (resultCheck.listData.length === 1) {
                                                            if (resultCheck.listData[0].value.includes('SISTEMAS-')) {
                                                                screen = notOilScreens.filter(src => src.ScreenName !== 'SpecialtyScreen' && src.ScreenName !== 'WorkCycleScreen');
                                                                screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                            } else if (resultCheck.listData[0].value === 'DISCIPLINA OPERACIONAL-3') {
                                                                screen = resultSite.data !== 'HUB' ? resultScreen.filter(scr => scr.ScreenName !== 'SystemScreen') : resultScreen.filter(scr => scr.ScreenName !== 'SystemScreen' && scr.ScreenName !== 'ComplianceMatrixbyPositionScreenAbordo');/**linea de ajuste*/
                                                                screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                            } else {
                                                                if (resultCheck.listData[0].value.includes('DISCIPLINA OPERACIONAL-')) {
                                                                    screen = notOilScreens.filter(scr => scr.ScreenName !== 'SystemScreen');
                                                                    screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                                }
                                                                else {
                                                                    screen = notOilScreens.filter(scr => scr.ScreenName !== 'SystemScreen' && scr.ScreenName !== 'WorkCycleScreen');
                                                                    screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                                }
                                                            }
                                                        } else if (resultCheck.listData.length === 0) {
                                                            screen = notOilScreens.filter(scr => scr.ScreenName !== 'SystemScreen' && scr.ScreenName !== 'SpecialtyScreen' && scr.ScreenName !== 'WorkCycleScreen');
                                                            screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                        } else {
                                                            let showAllScreens = false;
                                                            let showSystem = false;
                                                            let showCT = false;
                                                            for (let permission of resultCheck.listData) {
                                                                if (permission.value === 'DISCIPLINA OPERACIONAL-3' || permission.value === 'DISCIPLINA OPERACIONAL-2' || permission.value === 'DISCIPLINA OPERACIONAL-4') {
                                                                    showAllScreens = true;
                                                                }
                                                                if (permission.value.includes('SISTEMAS-')) {
                                                                    showSystem = true;
                                                                }

                                                                if (permission.value.includes('DISCIPLINA OPERACIONAL-')) {
                                                                    showCT = true;
                                                                }
                                                            }

                                                            if (!showSystem) {
                                                                notOilScreens = notOilScreens.filter(x => x.ScreenName !== 'SystemScreen');
                                                                resultScreen = resultScreen.filter(x => x.ScreenName !== 'SystemScreen');
                                                            }

                                                            if (!showCT) {
                                                                notOilScreens = notOilScreens.filter(x => x.ScreenName !== 'WorkCycleScreen');
                                                            }

                                                            if (resultScreen.some(scr => scr.ScreenName === 'ComplianceMatrixbyPositionScreen') && resultScreen.some(scr => scr.ScreenName === 'ComplianceMatrixbyPositionScreenAbordo')) {
                                                                resultScreen = resultScreen.filter(scr => scr.ScreenName !== 'ComplianceMatrixbyPositionScreenAbordo')
                                                            }

                                                            else {
                                                                notOilScreens.push(...resultScreen.filter(x => x.ScreenName === 'ComplianceMatrixbyPositionScreen')); /**linea de ajuste*/
                                                            }

                                                            screen = showAllScreens ? resultScreen : notOilScreens;
                                                            screen = resultAuth.User.IdCompany !== null ? screen : screen.filter(src => src.ScreenName !== 'CotplayHubScreen');
                                                        }
                                                    } else {
                                                        screen = notOilScreens;
                                                    }

                                                    screen.map(function (dato) {
                                                        if (dato.ScreenName == "ComplianceMatrixbyPositionScreenAbordo") {
                                                            dato.ScreenName = "ComplianceMatrixbyPositionScreen";
                                                        }
                                                        
                                                        return dato;
                                                    });
                                                    ApiService.getTokenErapids(data)
                                                        .then(
                                                            result => {
                                                                dispatch(ErapidsTokenSuccess(result));
                                                                dispatch(IDMScreenSuccess(screen));
                                                                dispatch(IDMSuccess(resultAuth));
                                                                dispatch(fetchEmployeeById(resultAuth.User.IdCompany)).then(() => {
                                                                    props.login(() => {
                                                                        props.history.push({
                                                                            pathname: resultScreen.find(x => x.ScreenName === 'EmployeeDashboardScreen') !== undefined ? resultScreen.find(x => x.ScreenName === 'EmployeeDashboardScreen').ActionUrl : resultScreen[0].ActionUrl,
                                                                            state: 'MI DATA de Login',
                                                                            isAuth: resultAuth.IsAuthenticated
                                                                        })
                                                                    }, true);
                                                                }
                                                                );

                                                            },
                                                            error => {
                                                                dispatch(ErapidsTokenFailure());
                                                                throw ({ error: error, message: 'Ops! user authentication failed' });
                                                            }
                                                        )
                                                });

                                        },
                                        error => {
                                            dispatch(IDMScreenFailure());
                                            throw ({ error: error, message: 'Ops! user authentication failed' });
                                        }
                                    );
                            },
                            errorSite => {
                                dispatch(getSiteIdFailure(errorSite.response !== undefined ? errorSite.response.data.message : errorSite.message));
                            }
                        )
                    } else {
                        message.error("Usuario y/o contrase" + String.fromCharCode(241) + "a incorrectos");
                    }
                },
                error => {
                    dispatch(IDMFailure());
                    throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}
export function fetchErapidsRefreshToken(data) {
    return async dispatch => {
        dispatch(ErapidsRefreshTokenBegin());
        await ApiService.getRefreshTokenErapids(data)
            .then(
                result => {
                    dispatch(ErapidsRefreshTokenSuccess(result));
                },
                error => {
                    dispatch(ErapidsRefreshTokenFailure(error));
                    // throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

export function fetchEmployeeById(id) {
    return async dispatch => {
        dispatch(EmployeeByIdBegin());
        await ApiService.getEmployeeById(id)
            .then(
                result => {
                    dispatch(EmployeeByIdSuccess(result));
                },
                error => {
                    dispatch(EmployeeByIdFailure());
                    throw ({ error: error, message: 'Ops! user authentication failed' });
                }
            )
    };
}

export function acceptDisclaimerBegin(data) {
    return async dispatch => {
        dispatch(AcceptDisclaimerBegin());
        await ApiService.acceptDisclaimer(data)
            .then(
                result => {
                    dispatch(AcceptDisclaimerSuccess(result.success));
                },
                error => {
                    dispatch(AcceptDisclaimerSuccess(false));
                    throw ({ error: error, message: 'Fallo al registrar la versión del disclaimer ' });
                }
            )
    };
}

export const AcceptDisclaimerBegin = () => ({
    type: ACCEPT_DISCLAIMER_BEGIN
});

export const AcceptDisclaimerSuccess = (data) => ({
    type: ACCEPT_DISCLAIMER_SUCCESS,
    payload: data
});



// Action: Function that returns an object with action data for reducer
export const IDMBegin = () => ({
    type: IDM_BEGIN
});
export const IDMSuccess = data => ({
    type: IDM_SUCCESS,
    payload: { data }
});
export const IDMFailure = error => ({
    type: IDM_FAILURE,
    payload: { error }
});


export const IDMScreenBegin = () => ({
    type: IDM_SCREEN_BEGIN
});
export const IDMScreenSuccess = data => ({
    type: IDM_SCREEN_SUCCESS,
    payload: { data }
});
export const IDMScreenFailure = error => ({
    type: IDM_SCREEN_FAILURE,
    payload: { error }
});
export const ErapidsTokenBegin = () => ({
    type: ERAPIDS_TOKEN_BEGIN
});
export const ErapidsTokenSuccess = data => ({
    type: ERAPIDS_TOKEN_SUCCESS,
    payload: { data }
});
export const ErapidsTokenFailure = error => ({
    type: ERAPIDS_TOKEN_FAILURE,
    payload: { error }
});

export const ErapidsRefreshTokenBegin = () => ({
    type: ERAPIDS_REFRESHTOKEN_BEGIN
});
export const ErapidsRefreshTokenSuccess = data => ({
    type: ERAPIDS_REFRESHTOKEN_SUCCESS,
    payload: { data }
});
export const ErapidsRefreshTokenFailure = error => ({
    type: ERAPIDS_REFRESHTOKEN_FAILURE,
    payload: { error }
});

export const EmployeeByIdBegin = () => ({
    type: EMPLOYEE_BY_ID_BEGIN
});
export const EmployeeByIdSuccess = data => ({
    type: EMPLOYEE_BY_ID_SUCCESS,
    payload: { data }
});
export const EmployeeByIdFailure = error => ({
    type: EMPLOYEE_BY_ID_FAILURE,
    payload: { error }
});

export const logout = () => ({
    type: DESTROY_SESSION
})

export const clearAllStates = () => ({
    type: CLEAR_ALL_STATES
})

export const getSiteIdRequest = () => ({
    type: GET_SITE_ID_REQUEST
});

export const getSiteIdSuccess = (data) => ({
    type: GET_SITE_ID_SUCCESS,
    payload: data
});

export const getSiteIdFailure = (error) => ({
    type: GET_SITE_ID_FAILURE,
    payload: { error }
});